import './ccf-close-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCloseIconProps extends SvgIconProps {}
/**
 * component used to display close icon
 * @param props - CcfCloseIconProps
 * @example - <CcfCloseIcon />
 * @returns SVG of close icon
 */
export function CcfCloseIcon(props: CcfCloseIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_close">
      <rect width="20" height="20" fill="none"/>
      <g id="Layer_2" data-name="Layer 2" transform="translate(3 3)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0 0)">
          <path  d="M7.928,7l5.894-5.894a.611.611,0,0,0,0-.862L13.756.178a.611.611,0,0,0-.862,0L7,6.072,1.106.178a.611.611,0,0,0-.862,0L.178.244a.611.611,0,0,0,0,.862L6.071,7,.178,12.895a.611.611,0,0,0,0,.862l.066.066a.611.611,0,0,0,.862,0L7,7.928l5.894,5.894a.611.611,0,0,0,.862,0l.066-.066a.611.611,0,0,0,0-.862Z" transform="translate(0 0)"/>
        </g>
      </g>
    </g>
    </SvgIcon>
    
  );
}

export default CcfCloseIcon;
